"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Provides a collective wrapper over multiple {@link IGraphTransformer}s.
 */
class CompoundGraphTransformer {
    /**
     * Initializes a new instance of the {@link CompoundGraphTransformer} class.
     * @param {IGraphTransformer} graphTransformers Other graph transforming facilities to use.
     */
    constructor(...graphTransformers) {
        this.graphTransformers = graphTransformers;
    }
    /** @inheritDoc */
    transform(graph, processor, options) {
        let result = graph;
        for (const graphTransformer of this.graphTransformers) {
            result = graphTransformer.transform(result, processor, options);
        }
        return result;
    }
}
exports.default = CompoundGraphTransformer;
//# sourceMappingURL=CompoundGraphTransformer.js.map